import axios from "axios";
import { combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
//import axios from "axios";

// reducer
import authReducer from "./auth";
import dashboardReducer from "./dashboard";
import monitoringReducer from "./monitoring";
import userReducer from "./user";
import clientReducer from "./client";
import korwilReducer from "./korwil";
import areaManagerReducer from "./areaManager";
import marketingReducer from "./marketing";
import supervisorReducer from "./supervisor";
import cabangReducer from "./cabang";
import pengajuanReducer from "./Pengajuan";
import pengajuanKoorReducer from "./PengajuanKoor";
import dashboardUtamaReducer from "./dashboardUtama";
import managementFeeReducer from "./ManagementFee";
import authKoorReducer from "./authKoordinator";
import korcabReducer from "./korCab";
import kunjunganReducer from "./kunjungan";
import dashboardUtamaProduktifReducer from "./dashboardUtamaProduktif";
import pengajuanProduktifReducer from "./PengajuanProduktif";
import authKoorProduktifReducer from "./authKoordinatorProduktif";
import pengajuanKoorProduktifReducer from "./PengajuanKoorProduktif";
import listUsahaReducer from "./listUsaha";
import scoringReducer from "./scoring";
import informasiDebiturReducer from "./informasidebitur";
// function
export * from "./auth/function";
export * from "./monitoring/function";
export * from "./errorHandler";
export * from "./user/function";
export * from "./client/function";
export * from "./korwil/function";
export * from "./areaManager/function";
export * from "./marketing/function";
export * from "./supervisor/function";
export * from "./cabang/function";
export * from "./dashboardUtama/function";
export * from "./ManagementFee/function";
export * from "./authKoordinator/function";
export * from "./PengajuanKoor/index";
export * from "./korCab/function";
export * from "./kunjungan/function";
export { showUrlDokumenKunjungan } from "./korCab/function";
export * from "./PengajuanProduktif/function";
export * from "./authKoordinatorProduktif/function";
export * from "./PengajuanKoorProduktif/function";
export * from "./dashboardUtamaProduktif/function";
export * from "./listUsaha/function";
export * from "./scoring/function";
export * from "./informasidebitur/function";
// server api
// export const baseUrl = process.env.REACT_APP_URL
export const baseUrl = "https://newapikalbar.ptbap.net/";
// export const baseUrl = "https://supercivilized-shawn-forficate.ngrok-free.dev/";
// export const baseUrl = "http://10.5.50.248:8065/";

export const baseAxios = axios.create({
  baseURL: baseUrl,
  //timeout: 10000,
});

const rootReducer = combineReducers({
  userReducer,
  authReducer,
  clientReducer,
  dashboardReducer,
  monitoringReducer,
  korwilReducer,
  areaManagerReducer,
  marketingReducer,
  supervisorReducer,
  cabangReducer,
  pengajuanReducer,
  pengajuanKoorReducer,
  dashboardUtamaReducer,
  managementFeeReducer,
  authKoorReducer,
  korcabReducer,
  kunjunganReducer,
  dashboardUtamaProduktifReducer,
  pengajuanProduktifReducer,
  authKoorProduktifReducer,
  pengajuanKoorProduktifReducer,
  listUsahaReducer,
  scoringReducer,
  informasiDebiturReducer,
});

export const store = createStore(
  rootReducer,
  composeWithDevTools(),
);
